import { v4 as uuidV4 } from 'uuid';
import { LOG_TRACE_HEADER } from '@origin-digital/sales-common-types-fns';

export const createTraceHeaders = (businessTraceId: string | undefined) => {
  return {
    [LOG_TRACE_HEADER.BUSINESS_TX_ID]: businessTraceId ?? '',
    [LOG_TRACE_HEADER.TRACE_ID]: uuidV4(),
  };
};
